import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActionsComponent } from "./actions.component";
import { SharedModule } from 'app/shared.module';

@NgModule({
  declarations: [ActionsComponent],
  imports: [CommonModule],
  exports: [ActionsComponent],
})
export class ActionsModule {}
